const en = require('./en.json');
const es = require('./es.json');
const fr = require('./fr.json');
const de = require('./de.json');
const nl = require('./nl.json');
const se = require('./se.json');
const da = require('./da.json');
const ja = require('./ja.json');

const locale_options = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    nl: 'Nederlands',
    se: 'Svenska',
    da: 'Dansk',
    ja: '日本語'
};

const locale_keys = ['en', 'es', 'fr', 'de', 'nl', 'se', 'da', 'ja'];

module.exports = {
    locale_options,
    locale_keys,
    en,
    es,
    fr,
    de,
    nl,
    se,
    da,
    ja
};
